/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { compose } from 'recompose'

import FamilyMembers from '../Constituents/list'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { location } = this.props

		if (!_.has(location.state, 'household')) {
			window.location.href = '/household'
		}
		const { household } = location.state
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Resident Profiling</a></li>
									<li className="breadcrumb-item"><Link to='/household'>Household</Link></li>
									<li className="breadcrumb-item active">Manage Household</li>
								</ol>
							</div>
							<h4 className="page-title">Manage Household {household.household_no}</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row gutter={16}>
									<Col md={12} sm={24}>
										<h4>
											<span style={{ color: 'gray' }}>Household Number:</span>
											<span style={{ marginLeft: 20 }}>{household.household_no}</span></h4>
									</Col>
									<Col md={12} sm={24}>
										<h4>
											<span style={{ color: 'gray' }}>House Number:</span>
											<span style={{ marginLeft: 20 }}>{household.house_no}</span></h4>
									</Col>
									<Col md={12} sm={24}>
										<h4>
											<span style={{ color: 'gray' }}>Street:</span>
											<span style={{ marginLeft: 20 }}>{household.street}</span></h4>
									</Col>
									<Col md={12} sm={24}>
										<h4>
											<span style={{ color: 'gray' }}>Sitio/Subdivision:</span>
											<span style={{ marginLeft: 20 }}>{household.address}</span></h4>
									</Col>
									<Col md={12} sm={24}>
										<h4>
											<span style={{ color: 'gray' }}>Purok:</span>
											<span style={{ marginLeft: 20 }}>{household.purok_name}</span></h4>
									</Col>
									<Col md={12} sm={24}>
										<h4>
											<span style={{ color: 'gray' }}>Purok Leader:</span>
											<span style={{ marginLeft: 20 }}>{household.purok_leader}</span></h4>
									</Col>
								</Row>
								<Row style={{ marginTop: 25 }}>
									<h4 style={{ color: 'gray' }}>Household Members</h4>
									<FamilyMembers household={household} />
								</Row>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const composed = compose(
	withRouter,
	observer
)

export default composed(Index)
